import { render, staticRenderFns } from "./unsubmitted-faculty.vue?vue&type=template&id=1053b4da&scoped=true&"
import script from "./unsubmitted-faculty.vue?vue&type=script&lang=js&"
export * from "./unsubmitted-faculty.vue?vue&type=script&lang=js&"
import style0 from "./unsubmitted-faculty.vue?vue&type=style&index=0&id=1053b4da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1053b4da",
  null
  
)

export default component.exports